/**
 * Counts requests that are on their way, so the dashboard can show a thin
 * progress bar at the top whenever something is loading or saving
 * (components/app/NetworkActivityBar.tsx). Background polls (job progress,
 * notifications, status checks) are left out so the bar only moves when a
 * person is waiting.
 */
type Listener = (busy: number) => void;
let busy = 0;
const listeners = new Set<Listener>();
const SILENT = [/\/api\/jobs\//, /\/api\/notifications/, /\/status(\?|$)/, /\/stream\b/, /\/api\/t\//, /\/api\/auth\/me\b/];

function emit() {
  for (const l of listeners) l(busy);
}

export function onActivity(l: Listener): () => void {
  listeners.add(l);
  l(busy);
  return () => listeners.delete(l);
}

export function track<T>(path: string, p: Promise<T>): Promise<T> {
  if (typeof window === "undefined" || SILENT.some((r) => r.test(path))) return p;
  busy += 1;
  emit();
  return p.finally(() => {
    busy = Math.max(0, busy - 1);
    emit();
  });
}
